import { requiresTimeslot } from "../../../models/Experience";
import { useCreatePurchaseStore } from "../../../stores/createPurchaseStore";
import { getArrivalErrorMessages, hasSomeEmptyRequiredFields } from "../helpers/PurchaseCreateValidationHelpers";

export const getPackageValidations = () => {
    const { purchase } = useCreatePurchaseStore.getState();
    const experiences = useCreatePurchaseStore.getState().getProductsInPurchase();
    const { errors } = useCreatePurchaseStore.getState();

    const getDisabledReasons = () => {
        const messages: string[] = [];
        let isQuestionnaireFieldNotAnswered = false;
        let isTimeslotNotSelected = false;

        messages.push(...getArrivalErrorMessages(errors ?? []));

        for (const item of purchase.items) {
            const experience = experiences.find((experience) => experience.id === item.product.id);
            const missingDateOrTime = !item.arrivalDate || (requiresTimeslot(experience!) && !item.arrivalTime);
            if (!isTimeslotNotSelected && (item.demographicLineItems.length === 0 || missingDateOrTime)) {
                messages.push(`Timeslot for ${experience?.name} is not selected`);
                isTimeslotNotSelected = true;
            }

            if (
                !item.disableRequiredFormFields &&
                hasSomeEmptyRequiredFields(item) &&
                !isQuestionnaireFieldNotAnswered
            ) {
                messages.push(
                    'Please complete the Guest Info questionnaire or toggle on "Ignore questionnaire validation"',
                );
                isQuestionnaireFieldNotAnswered = true;
            }

            if (experience?.group && item.quantity < experience.group?.orderMin) {
                messages.push("Quantity less than the minimum capacity allowed");
            }

            if (experience?.group?.outingMax && item.quantity > experience.group.outingMax) {
                messages.push("Quantity exceeds available capacity");
            }
        }

        return messages;
    };

    return { getDisabledReasons };
};
